export enum Direction {
    Asc,
    Desc,
}

export function sortByProperty<T>(collection: T[], property: keyof T, direction: Direction): T[] {
    const sorted = collection.splice(0).sort((a, b) => {
        if (a[property] === undefined && b[property] === undefined) {
            return 0;
        }
        if (a[property] === undefined || a[property] === null) {
            return -1;
        }
        if (b[property] === undefined || b[property] === null) {
            return 1;
        }

        if (a[property] < b[property]) {
            return -1;
        } else if (a[property] > b[property]) {
            return 1;
        } else {
            return 0;
        }
    });

    if (direction === Direction.Asc) {
        return sorted;
    } else {
        return sorted.reverse();
    }
}
